import { render, staticRenderFns } from "./BaseGridTag.vue?vue&type=template&id=5373255a"
import script from "./BaseGridTag.vue?vue&type=script&lang=js"
export * from "./BaseGridTag.vue?vue&type=script&lang=js"
import style0 from "./BaseGridTag.vue?vue&type=style&index=0&id=5373255a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports